export enum VerificationStatus {
  Unverified = "unverified",
  AwaitsVerification = "awaitsVerification",
  Verified = "verified",
  Invalid = "invalid",
}
